/**
 * <theme-dialog> pairs an opener button with a native <dialog> shown as a modal.
 * - [data-dialog-open] opens it
 * - [data-dialog-close], a backdrop click or Escape close it
 * - links with [data-dialog-close-on-click] close it too (same-page anchors)
 * - the attribute open-on-load opens it as soon as the page is ready
 */
class ThemeDialog extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.querySelectorAll('[data-dialog-open]').forEach((opener) => {
      opener.addEventListener('click', () => this.open());
    });

    this.dialog.addEventListener('click', (event) => {
      const clickedBackdrop = event.target === this.dialog;
      const clickedCloser = event.target.closest('[data-dialog-close], [data-dialog-close-on-click]');
      if (clickedBackdrop || clickedCloser) this.close();
    });

    if (this.hasAttribute('open-on-load')) this.open();
  }

  open() {
    if (!this.dialog.open) this.dialog.showModal();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }
}

if (!customElements.get('theme-dialog')) customElements.define('theme-dialog', ThemeDialog);
